export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4053d4ba49786e13fb258882123ed11b0638a5f1b7&name=revalidateCommunity!'